import * as React from 'react';

// API
import apibridge from '../../apibridge';

// UTILS
import { validationErrorsToString } from '../../utils';

// PACKAGES
import { SwitchTransition, CSSTransition } from 'react-transition-group';

// COMPONENTS
import NoInfoMessage from '../../components/NoInfoMessage';
import LoadingSpinner from '../../components/LoadingSpinner';

// ICONS
import { ReactComponent as DocumentIcon } from '../../assets/svg/document.svg';

// TYPES
import { PolicyPolicyTemplatesPolicyTemplate } from '../../api/models';

const PolicyTemplates: React.FC = () => {
	// Error and Loading state
	const [formErrorMessage, setFormErrorMessage] = React.useState<string>('');

	const [isLoading, setIsLoading] = React.useState<boolean>(true);

	// Set up data state
	const [policyTemplatesData, setPolicyTemplatesData] = React.useState<PolicyPolicyTemplatesPolicyTemplate[]>([]);

	const getPolicyTemplatesData = async () => {
		setIsLoading(true);

		const response = await apibridge.getPolicyTemplatesData();

		response.result = response.result || [];

		if (response.isError) {
			setIsLoading(false);

			setFormErrorMessage(
				response.validationErrors.length
					? validationErrorsToString(response.validationErrors)
					: response.message || 'An error has occurred'
			);
		} else {
			setIsLoading(false);

			setPolicyTemplatesData(response.result);
		}
	};

	React.useEffect(() => {
		getPolicyTemplatesData();
	}, []);

	return (
		<div className="page-general-layout complaints-page">
			{!!formErrorMessage ? (
				<div className="form-validation-error">{formErrorMessage}</div>
			) : (
				<SwitchTransition mode="out-in">
					<CSSTransition key={`key_${isLoading}`} timeout={600} classNames="standalone-fade" mountOnEnter unmountOnExit>
						{isLoading ? (
							<LoadingSpinner show={isLoading} />
						) : (
							<>
								<p className="sub-grey-text">
									ChildAware has created the following policy templates which your organisation may find useful when
									drafting or updating your policies.
								</p>

								{policyTemplatesData && policyTemplatesData.length > 0 ? (
									<section className="info-section mtop-0">
										<div className="section-header">
											<h2 className="header-name color-dark">Templates</h2>
										</div>

										<ul>
											{policyTemplatesData.map((item) => {
												return (
													<li key={item.id} className="row-container">
														<div className="row detail-row">
															<div className="col-auto pdl-0 pdr-0 icon-box">
																<DocumentIcon />
															</div>

															<div className="col-md-auto full-width">
																<div className="row detail-info complaint-page">
																	<div className="col-12 detail-name">{item.title}</div>
																</div>
															</div>

															<div className="col-auto pdr-0 link-group">
																{item && item.attachmentUrl && (
																	<a className="btn-text mtop-0 pdr-0" href={item.attachmentUrl} download>
																		Download
																	</a>
																)}
															</div>
														</div>
													</li>
												);
											})}
										</ul>
									</section>
								) : (
									<NoInfoMessage name="Policy Templates" />
								)}
							</>
						)}
					</CSSTransition>
				</SwitchTransition>
			)}
		</div>
	);
};

export default PolicyTemplates;
